var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"20250506150500"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "/chereads";

import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

Sentry.init({
  dsn: "https://49c89cb179b543bd8c28ca873a0de94f@jserror.webnovel.com/5",

  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.002,

  // allowUrls: [
  //   // only allow *www.yueimg.com and *www.chereads.com to report errors
  //   /https:\/\/(dev|oa|pre|)www\.yueimg\.com|https:\/\/(dev|oa|pre|)www\.chereads\.com/,
  // ],

  ignoreErrors: [
    // Random plugins/extensions
    "top.GLOBALS",
    // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
    "originalCreateNotification",
    "canvas.contentDocument",
    "MyApp_RemoveAllHighlights",
    "http://tt.epicplay.com",
    "Can't find variable: ZiteReader",
    "jigsaw is not defined",
    "ComboSearch is not defined",
    "http://loading.retry.widdit.com/",
    "atomicFindClose",
    // Facebook borked
    "fb_xd_fragment",
    // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
    // reduce this. (thanks @acdha)
    // See http://stackoverflow.com/questions/4113268
    "bmi_SafeAddOnload",
    "EBCallBackMessageReceived",
    // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
    "conduitPage",
    "<unknown>",
    /^ChunkLoadError: /,
  ],

  enabled: process.env.NODE_ENV === "production",

  // Setting this option to true will print useful information to the console while you're setting up Sentry.
  debug: false,

  replaysOnErrorSampleRate: 0,

  // This sets the sample rate to be 10%. You may want this to be 100% while
  // in development and sample at a lower rate in production
  replaysSessionSampleRate: 0,

  // You can remove this option if you're not planning to use the Sentry Session Replay feature:
  integrations: [
    Sentry.replayIntegration({
      // Additional Replay configuration goes in here, for example:
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  beforeSend(event, hint) {
    // 在这里添加过滤爬虫的逻辑判断
    if (isSpiderRequest(event)) {
      return null; // 返回null表示丢弃该事件
    }
    return event; // 返回事件表示发送该事件
  },
});

function isSpiderRequest(event) {
  // 判断逻辑，例如根据User-Agent头部判断是否为爬虫请求
  const userAgent = event.request.headers["User-Agent"];
  return (
    userAgent.includes("bot") ||
    userAgent.includes("Bot") ||
    userAgent.includes("spider")
  );
}
